import { render, staticRenderFns } from "./accountIcon.vue?vue&type=template&id=5d578bac&scoped=true"
import script from "./accountIcon.vue?vue&type=script&lang=js"
export * from "./accountIcon.vue?vue&type=script&lang=js"
import style0 from "./accountIcon.vue?vue&type=style&index=0&id=5d578bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d578bac",
  null
  
)

export default component.exports